import CurrentTeamEntityBox from './CurrentTeamEntityBox';

export default CurrentTeamEntityBox;
